// https://css-tricks.com/how-to-animate-the-details-element/

class DetailsAccordion {
    constructor() {
        // The <details> element
        this.element = null;
        // The <summary> element
        this.summary = null;
        // The content element
        this.content = null;
        // The animation object (so we can cancel it if needed)
        this.animation = null;
        // if the element is closing
        this.isClosing = false;
        // Store if the element is expanding
        this.isExpanding = false;
    }

    init(options) {
        this._setOptions(options);
        this._bindEvents();
    }

    _setOptions(options) {
        this.element = options.element;
        this.summary = this.element.querySelector('summary');
        this.content = this.element.querySelector('.j-details__content');
    }

    _bindEvents() {
        if (this.summary) {
            this.summary.addEventListener('click', this._onClick.bind(this));
        }
    }

    _onClick(event) {
        event.preventDefault();
        this.element.style.overflow = 'hidden';
        if (this.isClosing || !this.element.open) {
            // Check if the element is being closed or is already closed
            this._open();
        } else if (this.isExpanding || this.element.open) {
            // Check if the element is being opened or is already open
            this._shrink();
        }
    }

    _open() {
        // Apply a fixed height on the element
        this.element.style.height = `${this.element.offsetHeight}px`;
        // Force the [open] attribute on the details element
        this.element.open = true;
        // Wait for the next frame to call the expand function
        window.requestAnimationFrame(this._expand.bind(this));
    }

    _shrink() {
        // Set the element as "being closed"
        this.isClosing = true;

        // Store the current height of the element
        const startHeight = `${this.element.offsetHeight}px`;
        // Calculate the height of the summary
        const endHeight = `${this.summary.offsetHeight}px`;

        // If there is already an animation running
        if (this.animation) {
            // Cancel the current animation
            this.animation.cancel();
        }

        // Start a WAAPI animation
        this.animation = this.element.animate({
            // Set the keyframes from the startHeight to endHeight
            height: [startHeight, endHeight]
        }, {
            duration: 300,
            easing  : 'ease-out'
        });

        // When the animation is complete, call onAnimationFinish()
        this.animation.onfinish = () => {
            this._onAnimationFinish(false);
        };

        // If the animation is cancelled, isClosing variable is set to false
        this.animation.oncancel = () => {
            this.isClosing = false;
        };
    }

    _expand() {
        // Set the element as "being expanding"
        this.isExpanding = true;
        // Get the current fixed height of the element
        const startHeight = `${this.element.offsetHeight}px`;
        // Calculate the open height of the element (summary height + content height)
        const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

        // If there is already an animation running
        if (this.animation) {
            // Cancel the current animation
            this.animation.cancel();
        }

        // Start a WAAPI animation
        this.animation = this.element.animate({
            // Set the keyframes from the startHeight to endHeight
            height: [startHeight, endHeight]
        }, {
            duration: 300,
            easing  : 'ease-out'
        });

        // When the animation is complete, call onAnimationFinish()
        this.animation.onfinish = () => {
            this._onAnimationFinish(true);
        };

        // If the animation is cancelled, isExpanding variable is set to false
        this.animation.oncancel = () => {
            this.isExpanding = false;
        };
    }

    _onAnimationFinish(open) {
        // Set the open attribute based on the parameter
        this.element.open = open;
        // Clear the stored animation
        this.animation = null;
        // Reset isClosing & isExpanding
        this.isClosing = false;
        this.isExpanding = false;
        // Remove the overflow hidden and the fixed height
        // eslint-disable-next-line no-multi-assign
        this.element.style.height = this.element.style.overflow = '';
    }
}

export default DetailsAccordion;
